import React from "react";
import { Organization } from "@common/types/organization";
import { OrganizationAvatar } from "@components/avatar/OrganizationAvatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";

interface Props {
    organization: Organization;
}

/** A firm on the entity team: its logo, named in a tooltip. */
export const EntityOrganization: React.FC<Props> = ({ organization }) => (
    <AvatarTooltip title={organization.name} content="Organization">
        <OrganizationAvatar organization={organization} />
    </AvatarTooltip>
);
